import {
  LogIn,
  UserCircle,
  Search,
  LayoutGrid,
  Package,
  Heart,
  ShoppingCart,
  ShoppingBag,
  CreditCard,
  History,
  LocateFixed,
  RotateCcw,
  Star,
  Tag,
  Bell,
  MessageCircle,
  Coins,
  Headphones,
  LayoutDashboard,
  Store,
  Boxes,
  ClipboardList,
  XCircle,
  TicketPercent,
  Image,
  MessageSquare,
  Receipt,
  Wallet,
  BarChart3,
  ShieldCheck,
  Users,
  Building2,
  Layers,
  Eye,
  Percent,
  Truck,
  Mail,
  FileText,
  LineChart,
  Smartphone,
  type LucideIcon,
} from "lucide-react";

export type EcaFeatureIcon =
  | "login"
  | "profile"
  | "search"
  | "categories"
  | "product-details"
  | "wishlist"
  | "cart"
  | "checkout"
  | "payment"
  | "order-history"
  | "tracking"
  | "cancel-reorder"
  | "reviews"
  | "offers"
  | "notifications"
  | "chat"
  | "multi-currency"
  | "help-desk"
  | "dashboard"
  | "vendor-profile"
  | "product-mgmt"
  | "inventory"
  | "order-mgmt"
  | "cancellation"
  | "vendor-offers"
  | "banners"
  | "review-mgmt"
  | "transactions"
  | "payout"
  | "analytics"
  | "auth"
  | "admin-dashboard"
  | "user-mgmt"
  | "vendor-mgmt"
  | "brand-mgmt"
  | "product-oversight"
  | "admin-orders"
  | "commission"
  | "promotions"
  | "gateway"
  | "shipping"
  | "campaigns"
  | "cms"
  | "reports";

export const ecaFeatureIconMap: Record<EcaFeatureIcon, LucideIcon> = {
  login: LogIn,
  profile: UserCircle,
  search: Search,
  categories: LayoutGrid,
  "product-details": Package,
  wishlist: Heart,
  cart: ShoppingCart,
  checkout: ShoppingBag,
  payment: CreditCard,
  "order-history": History,
  tracking: LocateFixed,
  "cancel-reorder": RotateCcw,
  reviews: Star,
  offers: Tag,
  notifications: Bell,
  chat: MessageCircle,
  "multi-currency": Coins,
  "help-desk": Headphones,
  dashboard: LayoutDashboard,
  "vendor-profile": Store,
  "product-mgmt": Package,
  inventory: Boxes,
  "order-mgmt": ClipboardList,
  cancellation: XCircle,
  "vendor-offers": TicketPercent,
  banners: Image,
  "review-mgmt": MessageSquare,
  transactions: Receipt,
  payout: Wallet,
  analytics: BarChart3,
  auth: ShieldCheck,
  "admin-dashboard": LayoutDashboard,
  "user-mgmt": Users,
  "vendor-mgmt": Building2,
  "brand-mgmt": Layers,
  "product-oversight": Eye,
  "admin-orders": ClipboardList,
  commission: Percent,
  promotions: Tag,
  gateway: CreditCard,
  shipping: Truck,
  campaigns: Mail,
  cms: FileText,
  reports: LineChart,
};

export const ecaPlatformIconMap: Record<string, LucideIcon> = {
  customer: ShoppingBag,
  vendor: Store,
  admin: LayoutDashboard,
  "seller-app": Smartphone,
};
